var _rect, _rect2, _rect3, _text, _text2, _g, _path, _path2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg109(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "1232\uD68C \uB2F9\uCCA8\uBC88\uD638 \uC774\uC6D4\uC218 \uBD84\uC11D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    rx: 28,
    fill: "#eef7f5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 90,
    width: 245,
    height: 270,
    rx: 28,
    fill: "#fff",
    stroke: "#0f766e",
    strokeWidth: 7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 485,
    y: 90,
    width: 245,
    height: 270,
    rx: 28,
    fill: "#fff",
    stroke: "#8065c7",
    strokeWidth: 7
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 192,
    y: 145,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 32,
    fontWeight: 900,
    fill: "#0f766e"
  }, "1232\uD68C")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 607,
    y: 145,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 32,
    fontWeight: 900,
    fill: "#634ca8"
  }, "1233\uD68C \uD6C4\uBCF4")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "sans-serif",
    fontSize: 28,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "#172033"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 225,
    r: 45,
    fill: "#ffd666"
  }), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 235
  }, "?"), /*#__PURE__*/React.createElement("circle", {
    cx: 235,
    cy: 290,
    r: 45,
    fill: "#b9e6dc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 235,
    y: 300
  }, "?"), /*#__PURE__*/React.createElement("circle", {
    cx: 565,
    cy: 225,
    r: 45,
    fill: "#ffd666"
  }), /*#__PURE__*/React.createElement("text", {
    x: 565,
    y: 235
  }, "?"), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 290,
    r: 45,
    fill: "#d9ccff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 300
  }, "?"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M335 225h120",
    stroke: "#172033",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m430 195 35 30-35 30",
    fill: "none",
    stroke: "#172033",
    strokeWidth: 10
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 405,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 28,
    fontWeight: 900,
    fill: "#172033"
  }, "\uACB9\uCE68\uC740 \uBE44\uAD50\uC6A9 \xB7 \uC2E4\uC81C \uACB0\uACFC\uB294 \uCD94\uCCA8 \uD6C4 \uD655\uC778")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg109);
export default __webpack_public_path__ + "static/media/109-이월수.7e8bad771990ce4ae4b1c1377fb4dc07.svg";
export { ForwardRef as ReactComponent };